import {
  Card,
  CardContent,
  Typography,
  Grid2 as Grid,
  Box,
  Fade,
  Slide,
} from "@mui/material";

import QuickActionPermit from "./quickActionsComponents/QuickActionPermit";
import QuickActionValidateLicense from "./quickActionsComponents/QuickActionValidateLicense";
import { useState } from "react";
import ContractorSlip from "./quickActionsComponents/ContractorSlip";
import QuickActionIcons from "./quickActionsComponents/QuickActionIcons";
import { useSelector } from "react-redux";
import QuickActionContractorCard from "./quickActionsComponents/QuickActionContractorCard";

const QuickActions = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);

  const [foundContractor, setFoundContractor] = useState(null);

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          variant="h5"
          textAlign="center"
          gutterBottom
          fontWeight="bold"
        >
          Quick Actions
        </Typography>

        <Grid container mt={6}>
          <Grid size={{ xs: 4 }}>
            <QuickActionPermit />
          </Grid>
          <Grid
            size={{ xs: 4 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 10,
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
                display: "flex",
                alignItems: "center", // vertical center
                justifyContent: "center", // horizontal center
              }}
            >
              {/* Floating contractor slip */}
              <Box
                sx={{
                  position: "absolute",
                  zIndex: foundContractor ? 99999 : undefined,
                  top: 35,
                  left: 10,
                  right: -20,
                }}
              >
                <Fade in={!!foundContractor} timeout={300}>
                  <Slide direction="left" in={!!foundContractor} timeout={400}>
                    <div>
                      <ContractorSlip foundContractor={foundContractor} />
                    </div>
                  </Slide>
                </Fade>
              </Box>

              {/* Centered Icon Grid */}
              <QuickActionIcons />
            </Box>
          </Grid>

          {/* Private Provider only */}
          {currentSession === "privateProviderSession" ? (
            <Grid size={{ xs: 4 }} sx={{ position: "relative" }}>
              <QuickActionValidateLicense
                foundContractor={foundContractor}
                setFoundContractor={setFoundContractor}
              />
            </Grid>
          ) : (
            <Grid size={{ xs: 4 }}>
              <QuickActionContractorCard />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
